<div class="card card-custom card-stretch gutter-b">
  <div class="card-header align-items-center border-0 mt-4">

    <nav class="toolbar toolbar-icon align-content-center">
      <div class="rounded-pill d-flex align-items-center">
        <a type="button" class="btn btn-hover" routerLink="/dashboard">
          <i class="me-1 sidebar-text fa-solid fa-arrow-left"></i>
          <span class="types-custom__letter">Atrás</span>
        </a>

        <a type="button" class="btn btn-hover" [routerLink]="['/companysettings']">
          <i class="me-1 sidebar-text fa-solid fa-plus" ></i>
          <span class="types-custom__letter">Nuevo</span>
        </a>
      </div>
  </nav>

  </div>
  <div class="card-body pt-4">
    <div class="dropdown-divider"></div>
      <dx-data-grid
        id="gridContainer"
        [noDataText]="'No hay temas registrados'"
        [columnHidingEnabled]="false"
        [showColumnLines]="true"
        [showRowLines]="true"
        [rowAlternationEnabled]="true"
        (onRowDblClick)="onRowDblClick($event)"
        [dataSource]="themesData"
        [showBorders]="true" [allowColumnReordering]="true"
        [allowColumnResizing]="true" [columnAutoWidth]="true"
        [hoverStateEnabled]="true" [selectedRowKeys]="[]"
        [filterSyncEnabled]="true"
      >
        <dxo-search-panel
          [visible]="true"
          [highlightCaseSensitive]="true"
          [placeholder]="'Buscar'"
        >
        </dxo-search-panel>
        <dxo-filter-row [visible]="false"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-selection mode="single"></dxo-selection>
        <dxo-paging [pageSize]="10"></dxo-paging>
     
        <dxi-column dataField="code" caption="Código" alignment="center"></dxi-column>
        <dxi-column dataField="name" caption="Nombre" alignment="center"></dxi-column>
        <dxi-column type="buttons" [width]="100">
        <dxi-button [name]="'editar'" [icon]="'dx-icon-edit pointer'" [onClick]="editThemeClick" ></dxi-button>
          <dxi-button
            [name]="'borrar'"
            [icon]="'dx-icon-trash pointer'"
            [onClick]="deleteThemeClick"
          ></dxi-button>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>

